import { Component, signal, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../core/services/auth.service';

interface MenuItem {
  label: string;
  icon: string;
  route?: string;
  expanded: boolean;
  children?: { label: string; route: string }[];
}

@Component({
  selector: 'app-sidebar',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class Sidebar {
  private auth = inject(AuthService);

  menu = signal<MenuItem[]>([
    { label: 'Dashboard', icon: 'bi-speedometer2', route: '/dashboard', expanded: false },
    {
      label: 'Inventory', icon: 'bi-box', expanded: false,
      children: [
        { label: 'Certificates', route: '/inventory/certificates' },
        { label: 'Endpoints', route: '/inventory/endpoints' },
      ],
    },
    {
      label: 'Automations', icon: 'bi-gear', expanded: false,
      children: [
        { label: 'Automation Profiles', route: '/automations/profiles' },
        { label: 'Connectors', route: '/automations/connectors' },
        { label: 'Agents', route: '/automations/agents' },
        { label: 'Automation Runs', route: '/automations/runs' },
      ],
    },
    {
      label: 'Reporting', icon: 'bi-file-earmark-text', expanded: false,
      children: [
        { label: 'Audit Log', route: '/reporting/audit-log' },
      ],
    },
    {
      label: 'User Management', icon: 'bi-people', expanded: false,
      children: [
        { label: 'Users', route: '/user-management/users' },
      ],
    },
  ]);

  toggle(item: MenuItem): void {
    if (item.children) {
      this.menu.update((items) =>
        items.map((m) =>
          m === item ? { ...m, expanded: !m.expanded } : m
        )
      );
    }
  }

  logout(): void {
    this.auth.logout();
  }
}
